import React, { useState } from "react";
import { Table, Group, Text, ActionIcon, Box } from "@mantine/core";
import styles from "../../project-management/components/ProjectsTable/ProjectsTable.module.css";
import { IconCircleDashedCheck, IconCircleDashedX } from "@tabler/icons-react";
import { useGetLeavesRequest } from "api/leaveRequest/getLeaveRequest";
import { useUpdateLeaveStatus } from "api/leaveRequest/statusLeaveRequest";
import StatusModal from "./statusModal";
import { capitalizeFirstLetter } from "utils/capitalizeFirstLetter";

export default function LeaveRequestTable() {
  const { data, isLoading, error, refetch } = useGetLeavesRequest();
  const { mutate: updateLeaveStatus } = useUpdateLeaveStatus();
  const [opened, setOpened] = useState({
    id: "",
    isOpen: false,
  });
  // const [status, setStatus] = useState("");
  const [isApproved, setIsApproved] = useState(false);
  const pendingLeaves = data?.data?.pending ?? [];

  return (
    <Box
      style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px" }}
    >
      <div className={styles.container}>
        <Table
          withBorder
          className={styles.table}
          verticalSpacing="md"
          horizontalSpacing={20}
        >
          <thead>
            <tr>
              <th className={styles["name-column"]}>Employee Name</th>
              <th>Leave Type</th>
              <th>From</th>
              <th>To</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pendingLeaves.map((leave) => (
              <tr key={leave._id}>
                <td>
                  <Group spacing="xs">
                    <Text>
                      {leave.user.firstName} {leave.user.lastName}
                    </Text>
                  </Group>
                </td>
                <td>
                  <Text>{leave.leaveType}</Text>
                </td>
                <td>
                  <Text>
                    {new Date(leave.fromDate).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </Text>
                </td>
                <td>
                  <Text>
                    {new Date(leave.toDate).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </Text>
                </td>
                <td>
                  <Text>{leave.reason}</Text>
                </td>
                <td>
                  <Text>{capitalizeFirstLetter(leave.status)}</Text>
                </td>
                <td style={{ width: 120, display: "flex" }}>
                  <Group spacing="xs">
                    <ActionIcon
                      variant="light"
                      color="green"
                      onClick={() => {
                        setIsApproved(true);
                        setOpened({
                          id: leave._id,
                          isOpen: true,
                        });
                      }}
                    >
                      <IconCircleDashedCheck stroke={2} />
                    </ActionIcon>
                    <ActionIcon
                      color="red"
                      variant="light"
                      onClick={() => {
                        setIsApproved(false);
                        setOpened({
                          id: leave._id,
                          isOpen: true,
                        });
                      }}
                    >
                      <IconCircleDashedX stroke={2} />
                    </ActionIcon>
                  </Group>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <StatusModal
        opened={opened.isOpen}
        isApproved={isApproved}
        onClose={() =>
          setOpened({
            id: "",
            isOpen: false,
          })
        }
        leaveId={opened.id}
      />
    </Box>
  );
}
